'use client';

// npm packages
import React, { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/navigation';
import { useSelector } from 'react-redux';
import { cn } from '@/utils/cn';
import Icon from '@/app/components/Icon';
import Modal from '@/app/components/Modal';
import Text from '@/app/components/Text';
import Button from '@/app/components/Button';

function UserAccountV2({ option }) {
  const router = useRouter();
  const menuRef = useRef(null);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const [isOpenLogoutConfirmModal, setIsOpenLogoutConfirmModal] =
    useState(false);
  const { isLoggedIn } = useSelector((state) => state.auth);

  const handleClick = () => {
    setIsProfileMenuOpen(!isProfileMenuOpen);
  };

  const handleClickOutside = (event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      setIsProfileMenuOpen(false);
    }
  };

  useEffect(() => {
    if (isProfileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isProfileMenuOpen]);

  const handleCloseLogoutConfirmModal = (data) => {
    setIsOpenLogoutConfirmModal(data);
  };

  const handleLoginLogout = () => {
    if (isLoggedIn) {
      setIsOpenLogoutConfirmModal((preValue) => !preValue);
      if (isProfileMenuOpen) {
        setIsProfileMenuOpen((previousValue) => !previousValue);
      }
    } else {
      router.push('/login');
    }
  };

  const handleSelect = (item) => {
    router.push(item.url);

    if (isProfileMenuOpen) {
      setIsProfileMenuOpen((previousValue) => !previousValue);
    }
  };

  return (
    <>
      <div className="z-[512]" ref={menuRef}>
        <div className="relative inline-block">
          {/* Dropdown Button */}
          <Button
            type="link"
            className="flex items-center gap-[8px] focus:outline-none !p-0"
            onClick={handleClick}
          >
            <div className="min-w-[20px] min-h-[20px] border border-richcarmine rounded-[100px] bg-white hidden lg:flex justify-center items-center">
              <Icon type="user" width="16" height="16" />
            </div>
            {isLoggedIn && (
              <>
                <Text
                  type="paragraph"
                  className="hidden lg:block text-16 text-white font-medium font-encode-sans leading-20 tracking-[0.32px]"
                >
                  {' '}
                  Welcome
                </Text>
                <Icon
                  type="angle-down"
                  width="24"
                  height="24"
                  color="#fff"
                  className={cn(`hidden lg:block transition duration-200`, {
                    'rotate-180': isProfileMenuOpen,
                  })}
                />
              </>
            )}
          </Button>

          {/* Dropdown Menu */}
          <div
            className={cn(
              'w-[138px] invisible absolute right-0 mt-2 p-8 z-[512] rounded-8 bg-white text-sm/6 text-gunmetal shadow-language-toggle focus:outline-none opacity-0 scale-95 transition-all transform origin-top-right',
              {
                'visible opacity-100 scale-100': isProfileMenuOpen,
                '!mt-10': !isLoggedIn,
              },
            )}
          >
            {option?.map((item) => (
              <Button
                type="link"
                key={item?.id}
                onClick={() => handleSelect(item)}
                className="group w-full justify-start gap-2 rounded-lg !py-8 !px-16"
              >
                <Text
                  type="paragraph"
                  className="text-base text-coarse-wool font-medium"
                >
                  {item?.name}
                </Text>
              </Button>
            ))}
            <Button
              type="link"
              className="group flex w-full justify-start gap-2 rounded-lg !py-10 !px-16"
              onClick={handleLoginLogout}
            >
              <Text
                type="paragraph"
                className="text-base text-coarse-wool font-medium"
              >
                Log Out
              </Text>
            </Button>
          </div>
        </div>
      </div>
      {/* logout-confirm-modal */}
      <Modal
        type="logout-confirm-modal"
        onView={isOpenLogoutConfirmModal}
        onClose={handleCloseLogoutConfirmModal}
      />
    </>
  );
}

export default UserAccountV2;
